import { useQuery } from "@tanstack/react-query";

import { useSupabaseClient } from "@/hooks/use-supabase-client";
import type { Block, Page } from "@/types/database";

// Every other block hook (use-page-editor.ts's useBlocks) is scoped to one
// page, which is all the live editing canvas ever needs. The Data screen
// needs the whole site's blocks at once to summarize bound-vs-manual
// content — same "fetch across all of a site's pages in one query" shape
// already used by use-publish-scan.ts's advisory pass.
export function useAllSiteBlocks(pages: Page[]) {
  const getClient = useSupabaseClient();
  const pageIds = pages.map((page) => page.id);

  return useQuery({
    queryKey: ["all-site-blocks", pageIds],
    enabled: pageIds.length > 0,
    queryFn: async (): Promise<Block[]> => {
      const supabase = await getClient();
      const { data, error } = await supabase.from("blocks").select("*").in("page_id", pageIds);
      if (error) throw error;
      return (data ?? []) as Block[];
    },
  });
}
